export class LoginInput extends BX.Network.Component
{
	constructor(parameters)
	{
		super(parameters);

		this.root = null;
		this.input = null;
		this.firstInteraction = true;
		this.countrySelector = null;
		this.countryFlag = null;

		this.formState = {
			value: this.$data.value,
			country: this.$data.defaultCountry,
			isPhone: this.$data.phoneEnabled && this.$data.isPhone,
		};

		this.previousAutoValue = '';

		this.formState.value = this.checkIsPhone(this.formState.value);

		this.callChangeEvent = BX.debounce(this.callChangeEvent, 100, this);
	}

	description()
	{
		return {
			ssoMode: {
				type: Boolean,
				defaultValue: false
			},
			value: {
				type: String,
				defaultValue: ''
			},
			defaultCountry: {
				type: String,
				defaultValue: ''
			},
			countryTopList: {
				type: Array,
				defaultValue: []
			},
			phoneEnabled: {
				type: Boolean,
				defaultValue: true
			},
			isPhone: {
				type: Boolean,
				defaultValue: true
			},
			forceEmail: {
				type: Boolean,
				defaultValue: false
			},

		};
	}

	localization()
	{
		return {
			B24NET_INPUT_TITLE_SSO_EMAIL: BX.message('B24NET_INPUT_TITLE_SSO_EMAIL'),
			B24NET_INPUT_TITLE: (this.$data.phoneEnabled && !this.$data.forceEmail) ?
				BX.message('B24NET_INPUT_TITLE') : BX.message('B24NET_INPUT_TITLE_EMAIL')
		};
	}

	components()
	{
		return {
			PHONE_NUMBER: () =>
			{
				return new BX.PhoneNumber.Input({
					node: BX.create('INPUT', {
						props: {
							type: 'text',
						},
					}),
					flagNode: this.countryFlag,
					flagSize: 24,
					forceLeadingPlus: true,
					defaultCountry: this.$data.defaultCountry,
					countryPopupHeight: 350,
					countryPopupClassName: 'b24-network-auth-country-popup',
					countryTopList: this.$data.countryTopList,
					onChange: (data) => {
						this.formState.country = data.country;
						this.formState.value = data.value;

						if(this.input.value === this.previousAutoValue)
						{
							this.input.value = data.value;
							this.previousAutoValue = data.value;
							BX.focus(this.input);
						}
					},
					onCountryChange: (data) => {
						this.formState.country = data.country;
					}
				});
			}
		}
	}

	handleChange(e)
	{
		if(this.firstInteraction && this.input.value && this.input.value.length > 0)
		{
			this.firstInteraction = false;
			try
			{
				(window.dataLayer ? dataLayer.push : console.info)({
					'event': 'start_typing_login'
				});
			}
			catch (e)
			{
				//ignore all exceptions
			}
		}
		this.formState.value = this.checkIsPhone(this.input.value);
		this.formState.loginValid = /(^\+?[0-9]+$)|(^[^@]+@.+$)/i.test(this.formState.value);

		if(this.formState.isPhone)
		{
			this.countrySelector.classList.add('b24-network-auth-form-field-input-lang-show');
			this.input.classList.add('b24-network-auth-form-field-input-phone');
		}
		else
		{
			this.countrySelector.classList.remove('b24-network-auth-form-field-input-lang-show');
			this.input.classList.remove('b24-network-auth-form-field-input-phone');
		}

		this.formState.country = 'ru';

		this.callChangeEvent();

		if(this.formState.isPhone)
		{
			this.$components.PHONE_NUMBER.setValue(this.formState.value);
		}
	}

	handlerFocus(e)
	{
		this.callEvent('focus', [e]);
	}

	callChangeEvent()
	{
		this.callEvent('change', [this.formState]);
	}

	checkIsPhone(value)
	{
		const check = value.replace(/[()\s\-]+/g, '');
		if (!check.length && this.$data.forceEmail)
		{
			this.formState.isPhone = false;
			return value.trim();
		}
		else if(this.$data.phoneEnabled && /^\+?[0-9]*$/.test(check))
		{
			this.formState.isPhone = true;
			return check;

		}
		else
		{
			this.formState.isPhone = false;
			return value.trim();
		}
	}

	render()
	{
		let usePhoneInput = this.$data.phoneEnabled && this.$data.isPhone;
		if (this.$data.forceEmail && !this.$data.value.length)
		{
			usePhoneInput = false;
		}
		if(!this.input)
		{
			this.input =  BX.create('INPUT', {
				props: {
					type: 'text',
					id: 'login',
					className: 'b24-network-auth-form-field-input' + (usePhoneInput ? ' b24-network-auth-form-field-input-phone' : ''),
					value: this.$data.value
				},
				events: {
					bxchange: this.handleChange.bind(this),
					focus: this.handlerFocus.bind(this),
				}
			});
		}

		if(!this.countrySelector)
		{

			this.countrySelector = BX.create('DIV', {
				props: {
					className: 'b24-network-auth-form-field-input-lang' + (usePhoneInput ? ' b24-network-auth-form-field-input-lang-show' : '')
				},
			});

			this.countryFlag = this.countrySelector.appendChild(
				BX.create('SPAN', {
					style: {
						pointerEvents: 'none'
					},
					props: {
						className: 'b24-network-auth-form-flag-24'
					}
				})
			);

			BX.bind(this.countrySelector, 'click', this.$components.PHONE_NUMBER._onFlagClick.bind(this.$components.PHONE_NUMBER));
		}

		if(!this.root)
		{
			this.root = BX.create('DIV', {
				props: {
					className: 'b24-network-auth-form-field-input-block'
				},
				children: [
					this.input,
					this.countrySelector
				]
			})
		}

		if(!!this.$data.value)
		{
			this.handleChange();
		}

		const title = this.$data.ssoMode ? this.$localization.B24NET_INPUT_TITLE_SSO_EMAIL : this.$localization.B24NET_INPUT_TITLE;

		return [
			BX.create('LABEL', {
				props: {
					className: 'b24-network-auth-form-field-label',
					htmlFor: 'login'
				},
				html: title,
			}),
			this.root
		];
	}
}

